<td-wb-notification notificationType="error"
                    notificationSize="full-width">
  <td-wb-notification-header>
    <td-wb-inline-icon-wrapper>
      <span translate="tdWb.globalNotificationBanner.gaml.haltTrade.HEADER"></span>
    </td-wb-inline-icon-wrapper>
  </td-wb-notification-header>

  <span translate="tdWb.globalNotificationBanner.gaml.haltTrade.TEXT"></span>
  <a id="td-wb-gaml-halt-trade-global-notification-banner-link"
     tdWbHref="modal.gaml"
     [tdWbHrefParams]="{ entryPoint: 'GAML_ATTESTATION_HALT_TRADE_BANNER' }"
     [tdWbHrefTaggingEvent]="bannerAnalyticsEventLinkName">
    <u><span translate="tdWb.globalNotificationBanner.gaml.haltTrade.LINK"></span></u>
  </a>
</td-wb-notification>
